import FnTableItemComponent from './FnTableItemComponent';

const FnTableWrapper = ({ data, type, totalrow, showAction, handleAction }) => {

    return (
        <div className="card shadow mb-4">
            <div className="">
                <div className="table-responsive">
                    <div id="dataTable_wrapper" className="dataTables_wrapper dt-bootstrap4">
                        <div className="">
                            <div className="">
                                <FnTableItemComponent data={data} totalrow={totalrow} showAction={showAction} handleAction={handleAction} onEdit={(id) => {
                                    console.log("Edit Contest Id:", id);
                                    // navigate(`/edit-contest/${id}`);
                                    alert(`Navigate to edit page for contest ID: ${id}`);
                                }}
                                    onDelete={(id) => {
                                        console.log("Delete Contest Id:", id);
                                        // dispatch(deleteContest(id));
                                        alert(`Contest with ID ${id} deleted (mock)`);
                                    }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FnTableWrapper;
